<template lang="pug">
div(v-if="neeurofitReports.length > 0" class="neeurofit-section w-100 mt-4 px-3")
    div(class="d-flex align-items-center mb-3" style="gap: 0.5rem;")
        b-icon(icon="file-earmark-bar-graph" class="neeurofit-icon")
        h5(class="m-0 neeurofit-title") Neeurofit Reports
    div(class="d-flex flex-column" style="gap: 0.75rem;")
        a(
            v-for="report in neeurofitReports"
            :key="report.crb5c_fileid"
            :href="report.downloadUrl || report.crb5c_fileurl"
            target="_blank"
            rel="noopener noreferrer"
            class="report-card d-flex justify-content-between align-items-center p-3 text-decoration-none"
            :class="{ 'report-card--disabled': !report.downloadUrl && !report.crb5c_fileurl }"
            @click.prevent="openReport(report)"
        )
            div(class="d-flex align-items-center" style="gap: 0.75rem;")
                b-icon(icon="file-earmark-pdf" class="report-icon")
                div
                    p(class="m-0 report-name") {{ report.crb5c_name }}
                    p(class="m-0 report-date") {{ formatDate(report.createdon) }}
            b-icon(icon="box-arrow-up-right" class="open-icon")

div(v-else-if="isLoadingReports" class="w-100 mt-4 px-3 d-flex justify-content-center")
    b-spinner(small variant="secondary")
</template>

<script>
export default {
    props: {
        clientId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            neeurofitReports: [],
            isLoadingReports: false,
        };
    },
    watch: {
        clientId: {
            handler(val) {
                if (val) this.fetchReports(val);
            },
            immediate: true,
        },
    },
    methods: {
        openReport(report) {
            const url = report.downloadUrl || report.crb5c_fileurl;
            if (url) window.open(url, '_blank', 'noopener,noreferrer');
        },
        async fetchReports(clientId) {
            this.isLoadingReports = true;
            this.neeurofitReports = [];
            try {
                const { data } = await this.$root.axios.get(
                    `/neeurofit/${clientId}`
                );
                this.neeurofitReports = Array.isArray(data) ? data : [];
            } catch {
                this.neeurofitReports = [];
            } finally {
                this.isLoadingReports = false;
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            const d = new Date(dateStr);
            return d.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.neeurofit-title {
    color: #52246b;
    font-weight: 600;
}
.neeurofit-icon {
    color: #8967b3;
    font-size: 1.2rem;
}
.report-card {
    background-color: #fff;
    border: 1px solid #d8c4ec;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(89, 36, 107, 0.08);
    cursor: pointer;
    transition: box-shadow 0.15s ease;

    &:hover {
        box-shadow: 0 3px 8px rgba(89, 36, 107, 0.18);
    }
}
.report-icon {
    font-size: 1.4rem;
    color: #8967b3;
}
.report-name {
    font-size: 0.9rem;
    font-weight: 500;
    color: #26263e;
}
.report-date {
    font-size: 0.75rem;
    color: #888;
}
.open-icon {
    color: #8967b3;
    font-size: 0.9rem;
    flex-shrink: 0;
}
</style>
